import { GOLD_PRICE_TYPE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function GetGoldPriceType(userType=null){
  let api = `${GOLD_PRICE_TYPE_API}`;
  if(userType === 'admin'){
    api = `${api}admin/`;
  }
  return axiosHttp.get(api);
}
